
<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 15.7174H14.3667C13.7 15.7174 13.0667 15.9758 12.6 16.4424L11.175 17.8508C10.525 18.4924 9.46668 18.4924 8.81668 17.8508L7.39166 16.4424C6.925 15.9758 6.28333 15.7174 5.625 15.7174H5C3.61667 15.7174 2.5 14.6091 2.5 13.2425V4.15076C2.5 2.78409 3.61667 1.67578 5 1.67578H15C16.3833 1.67578 17.5 2.78409 17.5 4.15076V13.2425C17.5 14.6008 16.3833 15.7174 15 15.7174Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10 8.33253C11.0724 8.33253 11.9417 7.4632 11.9417 6.39085C11.9417 5.3185 11.0724 4.44922 10 4.44922C8.92768 4.44922 8.05835 5.3185 8.05835 6.39085C8.05835 7.4632 8.92768 8.33253 10 8.33253Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.3334 13.0487C13.3334 11.5487 11.8417 10.332 10 10.332C8.15835 10.332 6.66669 11.5487 6.66669 13.0487" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  </template>
      
  <script>
      export default {
        name: 'ProjectIcon',
        data() {
    return {
      
    }
  },
  computed: {
  },
      };
  </script>
      